import {createFeatureSelector, createSelector} from "@ngrx/store";
import {workingGroupsFeatureKey, WorkingGroupsState} from "../reducers/working-groups.reducer";

const workingGroupsFeatureState = createFeatureSelector<WorkingGroupsState>(workingGroupsFeatureKey);

export const getWorkingGroups = createSelector(
  workingGroupsFeatureState,
  state => state.workingGroups ?? []
);

export const getSelectedWorkingGroupId = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupId ?? ""
);

export const getSelectedWorkingGroup = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroup ?? null
);

export const getWorkingGroupTypes = createSelector(
  workingGroupsFeatureState,
  state => state.workingGroupTypes ?? []
);

export const getWorkingGroupStats = createSelector(
  workingGroupsFeatureState,
  state => state.workingGroupsStats ?? null
);

export const getSelectedWorkingGroupPosts = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupPosts ?? []
);

export const getSelectedWorkingGroupPostsCount = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupPostsCount ?? null
);

export const getSelectedWorkingGroupRequests = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupRequests ?? []
);

export const getSelectedWorkingGroupRequestId = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupRequestId ?? ""
);

export const getSelectedWorkingGroupPostDocuments = createSelector(
  workingGroupsFeatureState,
  state => state.selectedWorkingGroupPostDocuments ?? []
);

export const getTotalDocumentCount = createSelector(
  workingGroupsFeatureState,
  state => state.totalDocuments ?? 0
);
